<template>
  <el-container>
    <el-container v-if="$route.meta.keepAlive"
    v-loading="loadingShow"
    element-loading-text=""
    element-loading-spinner="indexLoading"
    element-loading-background="rgba(255, 255, 255, 1)">
      <el-header height="64px">
        <!-- 顶部导航栏 -->
        <div class="header-box clearfix" :class="{'close':menuClose,'active':$route.meta.sidebar==false}">
          <div class="headerNav clearfix">
            <div v-for="item in topMenuList" :key="item.id" :class="{'active':currentMenuT==item.activeName}">
              <router-link :to ="{name:item.name}" v-if="item.activeName!=='/accountInfoCenter'">{{item.title}}</router-link>
            </div>
          </div>
          <div class="userBox" >
            <el-dropdown v-if="userInfoDisplay&&userInfo.userName!==''">
              <div class="clearfix user">
                <!-- <div class="avatar"><i class="iconfont icon-avatar"></i></div> -->
                <p>{{userInfo.userName}}（{{userInfo.userRoleName}}）</p>
                <!-- <i class="el-icon-arrow-down el-icon--right fl"></i> -->
              </div>
              <el-dropdown-menu slot="dropdown" class="userMenu">
                <!-- <el-dropdown-item class="userMailbox"><p>{{userInfo.userEmail}}</p></el-dropdown-item>
                <el-dropdown-item v-permission="'user:password'"><router-link :to ="{name:'changePassword'}" tag="p">修改密码</router-link></el-dropdown-item> -->
                <el-dropdown-item class="userMailbox"><router-link :to ="{name:'userInfoCenter'}" tag="p">账号信息管理</router-link></el-dropdown-item>
                <el-dropdown-item><div @click="dropOut"><span>退出账号</span></div></el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <p class="help-doc" @click="gotoHelp"><span>帮助</span></p>
          </div>
          <!-- <el-dropdown class="avatarBox">
            <div class="clearfix user">
              <div class="avatar"><i class="iconfont icon-avatar"></i><div class="num" v-if="isQc">5</div></div>
            </div>
            <el-dropdown-menu slot="dropdown" class="userMenu">
              <el-dropdown-item v-if="isQc"><div @click="tojuliang"><span>巨量引擎</span></div></el-dropdown-item>
              <el-dropdown-item v-else><div @click="toqianchuan"><span>巨量千川</span></div></el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown> -->
          <!-- 消息通知 -->
          <messageNotice ref="message"></messageNotice>
          <el-dropdown class="platform" v-if="userInfo.userRole!=='daoyoudao'">
            <div class="clearfix user">
            <p class="el-dropdown-link">
              {{ isQc ? "巨量千川" : "巨量引擎"}}<i class="el-icon-arrow-down el-icon--right"></i>
            </p>
            </div>
            <el-dropdown-menu slot="dropdown" class="userMenu">
              <el-dropdown-item v-if="isQc"><div @click="tojuliang"><span>巨量引擎</span></div></el-dropdown-item>
              <el-dropdown-item v-else><div @click="toqianchuan"><span>巨量千川</span></div></el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-header>
      <el-dialog
        :visible='versionInfoVisible'
        title="更新说明"
        @close="closeVersionInfo()"
        :close-on-click-modal="false"
        width="435px"
        class="versionInfoDialog">
        <!-- 当前版本：{{versionInfo.versionNumber}} -->
        <div class="version-img"></div>
        <div class="info-box">
          <span v-for="(item,index) in versionInfo.versionContent" :key="index">{{item}}</span>
        </div>
      </el-dialog>
      <!-- 有侧边栏 -->
      <el-container v-if="$route.meta.sidebar!=false">
        <el-aside :width="asideWidth" class="leftMenu" :class="{'close':menuClose,'open':!menuClose}">
        </el-aside>
        <el-aside :width="asideWidth" class="leftMenu" style="position: fixed;" :class="{'close':menuClose,'open':!menuClose}">
          <!-- 侧边栏 -->
          <el-menu :default-active="currentMenuL" class="con">
            <div class="top">
              <div class="navBtn" @click="navBtnClick">
                <i v-if="navBtnShow=='open'" class="iconfont icon-navBtnOpen"></i>
                <i v-else class="iconfont icon-navBtnClose"></i>
              </div>
              <div class="logo">
                <i class="iconfont icon-logo"></i><span>道有道智投RPA</span>
              </div>
            </div>
            <div @mouseover="menuHoverOver" @mouseout="menuHoverOut">
              <!-- <div v-if="$route.path=='/changePassword'">
                <el-menu-item index="/changePassword">
                    <router-link class="itemBox" :to ="{name:'changePassword'}" tag='div'>
                      <i class="iconfont icon-change"></i>
                      <span>修改密码</span>
                    </router-link>
                  </el-menu-item>
              </div> -->
              <div>
                <div v-for="item in leftMenuList" :key="item.name">
                  <div class="sub-menu" v-if="item.subMenu">
                      <div class="sub-menu-title itemBox" :class="{'active':$route.path.indexOf(item.path)!==-1,'show':item.meta.subMenuShow}" @click="selectMenu(item)">
                        <i :class="'iconfont '+item.meta.iconName"></i>
                        <span>{{item.meta.title}}</span>
                        <!-- <router-link :to ="{name:item.name}" tag='span'>{{item.meta.title}}</router-link> -->
                        <i class="el-icon-arrow-up" :class="{'down':item.meta.subMenuShow}"></i>
                      </div>
                      <div class="sub-menu-text">
                        <div class="text-bg">
                          <b>{{item.meta.title}}</b>
                          <p v-for="(menuItem,index) in item.subMenu" :key="index" :class="{'active':$route.path.indexOf(menuItem.name)!==-1}">
                            <router-link :to ="{name:menuItem.name}" tag='span'>{{menuItem.title}}</router-link>
                          </p>
                        </div>
                      </div>
                      <el-collapse-transition>
                        <div v-if="item.meta.subMenuShow&&item.subMenu">
                          <div class="sub-menu-content">
                            <div class="sub-menu-item" v-for="(menuItem,index) in item.subMenu" :key="index" :class="{'active':$route.path.indexOf(menuItem.name)!==-1}">
                              <router-link :to ="{name:menuItem.name}" tag='div'>{{menuItem.title}}</router-link>
                            </div>
                          </div>
                        </div>
                      </el-collapse-transition>
                  </div>
                  <el-menu-item :index="item.path" v-else @click="selectMenu(item)">
                    <router-link class="itemBox" :to ="{name:item.name}" tag='div'>
                      <i :class="'iconfont '+item.meta.iconName"></i>
                      <span>{{item.meta.title}}</span>
                      <div class="text"><p>{{item.meta.title}}</p></div>
                    </router-link>
                  </el-menu-item>
                </div>
              </div>
            </div>
          </el-menu>
        </el-aside>
        <el-main class="main">
          <div style="padding: 0.61rem 0.45rem 0.32rem;">
            <router-view></router-view>
          </div>
        </el-main>
      </el-container>
      <!-- 无侧边栏 -->
      <el-container v-if="$route.meta.sidebar==false">
        <el-aside :width="asideWidth" class="leftMenu active" style="position: fixed;">
            <div class="logo">
              <i class="iconfont icon-logo"></i><span>道有道智投RPA</span>
            </div>
        </el-aside>
        <el-main class="main" style="padding-bottom:0 !important">
            <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
     <!-- 登录页 -->
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </el-container>
</template>

<script>
// import myLocalStorage from './config/myLocalStorage'
import { mapState, mapMutations } from 'vuex'
import messageNotice from '@/components/messageNotice'
export default {
  name: 'App',
  components: { messageNotice },
  data () {
    return {
      // adReportMenu: false,
      bodyWidth: document.body.offsetWidth, // 这里是给到了一个默认值 （这个很重要）
      breadList: [], // 路由集合
      asideWidth: '200',
      navBtnShow: 'open',
      menuClose: false,
      userInfoDisplay: true,
      versionInfoVisible: false,
      qchelpUrl: 'https://thoughts.teambition.com/sharespace/61c1995ddc260400413be573',
      jlhelpUrl: 'https://thoughts.teambition.com/sharespace/61c18d09cf18920041550fd0'
    }
  },
  created () {
    // 获取路由名称生成面包屑导航
    // this.getRouteName(this)
    // console.log('this.$route.path', this.$route.path)
    // console.log(this.currentMenuT)
    // console.log(this.currentMenuL)
    // this.getBreadcrumb()
    // 加载左侧导航
    // 未拿到用户信息,权限判断有问题.
    // console.log('当前路由>>>>>>>>>>>>>>>>>>>>>>' + this.$route.path)
    // if (this.$route.path !== '/' && this.$route.path !== '/login' && this.$route.path !== '/register' && this.$route.path !== '/protocol' && this.$route.path !== '/privacyPolicy') {
    //   // 获取用户信息
    //   this.getUserInfo()
    //   this.getTopMenuList()
    //   this.getMenuList(this)
    // }
  },
  mounted () {
    // console.log('app mounted')
    // console.log(this.currentMenuT)
    // console.log(this.currentMenuL)
    window.onresize = () => {
      return (() => {
        this.fontsize()
      })()
    }
    this.fontsize()
    console.log(this.userInfo)
  },
  watch: {
    versionInfo() {
      // 后台返回信息，显示弹窗
      if (this.versionInfo.versionNumber) {
        this.versionInfoVisible = true
      }
      // console.log(localStorage.VERSION_CODE, this.versionInfo.versionNumber)
      // if (!localStorage.VERSION_CODE || localStorage.VERSION_CODE !== this.versionInfo.versionNumber) {
      //   this.versionInfoVisible = true
      //   localStorage.setItem('VERSION_CODE', this.versionInfo.versionNumber)
      // }
    },
    $route(to) {
      console.log('to.name', to.name)
      if (!this.menuClose) {
        this.leftMenuList.forEach(item => {
          console.log('item', item)
          item.meta.subMenuShow = false
          if (item.subMenu) {
            item.subMenu.forEach(sub => {
              if (to.path.indexOf(sub.name) !== -1) {
                // 显示子菜单
                item.meta.subMenuShow = true
              } else {
                // if (item.meta.subMenuShow) {
                //   item.meta.subMenuShow = false
                // }
              }
            })
          }
        })
      } else {
        this.selectMenu('allClose')
      }
    }
  },
  methods: {
    gotoHelp() {
      let url = this.isQc ? this.qchelpUrl : this.jlhelpUrl
      window.open(url)
    },
    async toqianchuan() {
      // 去千川
      // this.$router.push({path: '/qianchuan/putin/manage'})
      await this.$store.dispatch('getTopMenuList', 1)
      let name = this.$store.getters.topMenuList[0].name
      this.$router.push({name: name})
      localStorage.platformType = 2
      localStorage.screeningProduct = ''
      localStorage.screeningProject = ''
      this.saveSwitchLog()
    },
    async tojuliang() {
      // 去巨量, 路由拦截会处理跳转.
      await this.$store.dispatch('getTopMenuList', 0)
      let name = this.$store.getters.topMenuList[0].name
      this.$router.push({name: name})
      localStorage.platformType = 1
      localStorage.screeningProduct = ''
      localStorage.screeningProject = ''
      this.saveSwitchLog()
    },
    saveSwitchLog() {
      this.$service
        .post('/api/user/saveSwitchLog', {platform: localStorage.platformType})
        .then(res => {
          if (res.code === 200) {
          }
        })
        .catch(Err => {
        })
    },
    // 关闭版本更新弹窗
    closeVersionInfo() {
      this.versionInfoVisible = false
    },
    // 页面切换修改面包屑
    getBreadcrumb () {
      this.breadList = this.$route.matched
    },
    fontsize () {
      let designSize = 1920 // 设计图尺寸
      let wW = document.body.offsetWidth // body宽度
      let rem
      if (wW > 1127) {
        rem = wW * 100 / designSize
      } else { // 字体最小是14px
        rem = 1127 * 100 / designSize
      }
      document.documentElement.style.fontSize = rem + 'px'
    },
    response () {
      this.$service.get('/api/test/response').then(res => {
        console.log(res)
      }).catch(Err => {
        this.btnLoading = false
      })
    },
    navBtnClick () {
      // 点击开合导航
      // 如果导航关闭样式关闭
      if (this.menuClose === false) {
        // 关闭子导航
        this.navBtnShow = 'close'
        this.menuClose = true
        this.asideWidth = '75'
        this.selectMenu('allClose')
      } else {
        this.navBtnShow = 'open'
        this.menuClose = false
        this.asideWidth = '200'
        let pathName = this.$route.meta.parents
        if (pathName) {
          let thisItem = {name: pathName}
          this.selectMenu(thisItem)
        }
      }
    },
    menuHoverOver () {
      // 鼠标移入左侧导航
      // if (this.menuClose === true) {
      //   this.menuClose = false
      // }
    },
    menuHoverOut () {
      // 鼠标移出左侧导航
      // if (this.navBtnShow === 'close') {
      //   this.menuClose = true
      // }
    },
    // 退出登录
    dropOut () {
      // console.log('退出登录')
      // 清除 storage
      // myLocalStorage.removeData('dydnz_access_token')
      // myLocalStorage.removeData('dydnz_refresh_token')
      this.userInfoDisplay = false
      this.clearUserInfo()
      // 清除素材、标题、关键字选中状态
      // this.delMaterialCount('picture', [], 'all')
      // this.delMaterialCount('keyword', [], 'all')
      // this.delMaterialCount('title', [], 'all')
      // 清除localStorage
      // 第一步
      // window.localStorage.removeItem('basicInfoForm')
      // window.localStorage.removeItem('adGroupList')
      // window.localStorage.removeItem('adGroupListCount')
      // window.localStorage.removeItem('strategyList')
      // window.localStorage.removeItem('strategyListCount')
      // window.localStorage.removeItem('selectedStrategyForm')
      // window.localStorage.removeItem('userOrientationList')
      // window.localStorage.removeItem('userOrientationListCount')
      // window.localStorage.removeItem('keywordList')
      // window.localStorage.removeItem('keywordListCount')
      // window.localStorage.removeItem('keywordDefault')
      // window.localStorage.removeItem('creativityForm')
      // window.localStorage.removeItem('materialTab')
      // window.localStorage.removeItem('pictureList')
      // window.localStorage.removeItem('videoList')
      // window.localStorage.removeItem('titleList')
      // window.localStorage.removeItem('creativityDefault')
      // window.localStorage.removeItem('planForm')
      // // 第二步
      // window.localStorage.removeItem('planId')
      // window.localStorage.removeItem('submitRulesForm')
      // 跳转
      setTimeout(() => {
        window.localStorage.clear()
        // localStorage.setItem('VERSION_CODE', this.versionInfo.versionNumber)
        this.$router.push('/empty')
        this.userInfoDisplay = true
      }, 100)
    },
    // 选中菜单
    selectMenu(thisItem) {
      console.log('thisItem', thisItem)
      if (thisItem === 'allClose') {
        this.leftMenuList.forEach(item => {
          this.$nextTick(() => {
            // 子菜单 关闭
            item.meta.subMenuShow = false
          })
        })
      } else if (!this.menuClose) {
        this.leftMenuList.forEach(item => {
          this.$nextTick(() => {
            if (item.name === thisItem.name && item.subMenu) {
              // 当前子菜单 展开/关闭
              item.meta.subMenuShow = !item.meta.subMenuShow
            } else {
              // 其他子菜单 关闭
              item.meta.subMenuShow = false
            }
          })
        })
      }
    },
    // getUserInfo () {
    //   // 用户信息为空时再请求更新
    //   if (!this.userInfo.userName || !this.userInfo.userRoleName) {
    //     this.$store.dispatch('getUserInfo')
    //   }
    // },
    // getTopMenuList () {
    //   if (this.topMenuList.length === 0) {
    //     this.$store.dispatch('getTopMenuList')
    //   }
    // }
    ...mapMutations(['clearUserInfo'])
  },
  computed: {
    ...mapState(['currentMenuL', 'currentMenuT', 'loadingShow', 'leftMenuList', 'userInfo', 'versionInfo', 'topMenuList']),
    isQc() {
      return this.$route.path.startsWith('/qianchuan')
    }
  }
}
</script>

<style lang="less">
@import './assets/iconfont/iconfont.css';
@import './styles/common/base.less';
@import './styles/common/common.less';
@import './styles/app.less';
@import './styles/common/nav.less';
// introJs
// @import './styles/introJs.css';
</style>



// WEBPACK FOOTER //
// src/App.vue